import { render } from "./videoSection.vue?vue&type=template&id=19d5e0ec&scoped=true"
import script from "./videoSection.vue?vue&type=script&lang=js"
export * from "./videoSection.vue?vue&type=script&lang=js"

import "./videoSection.vue?vue&type=style&index=0&id=19d5e0ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d5e0ec"]])

export default __exports__